import React from 'react'
import COLORS from '../../../styles/colors'

const defaultSize = {
  width: 40,
  height: 40,
}

const Elevator = ({ style = {}, color = COLORS.brand.primary }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    style={{ ...defaultSize, ...style }}
    viewBox='0 0 40 39.985'
  >
    <g fill={color} transform='translate(0 -0.097)'>
      <path
        d='M32.4,3.914H24.453V1.133A1.037,1.037,0,0,0,23.417.1H16.578a.585.585,0,0,0,0,1.171h6.7V3.914h-12.6V1.268h3.149a.585.585,0,0,0,0-1.171H10.549A1.037,1.037,0,0,0,9.513,1.133V3.914H1.569A1.57,1.57,0,0,0,0,5.482V39.5a.585.585,0,0,0,.585.585H33.38a.585.585,0,0,0,.585-.585V5.482A1.57,1.57,0,0,0,32.4,3.914Zm-14.485,35H16.053V9.489h1.859Zm10.63,0H19.083V9.489h9.459Zm4.252,0H29.714V9.414a1.1,1.1,0,0,0-1.1-1.1H5.348a1.1,1.1,0,0,0-1.1,1.1V28a.585.585,0,1,0,1.171,0V9.489h9.459V38.911H5.423V30.692a.585.585,0,1,0-1.171,0v8.219H1.171V5.482a.4.4,0,0,1,.4-.4H32.4a.4.4,0,0,1,.4.4Z'
        transform='translate(0)'
      />
      <path
        d='M449.674,251.091a.586.586,0,0,0,.585-.585v-.768a1.415,1.415,0,0,0-1.413-1.413h-2.435A1.415,1.415,0,0,0,445,249.737v7.728a1.415,1.415,0,0,0,1.413,1.413h2.435a1.415,1.415,0,0,0,1.413-1.413v-4.248a.585.585,0,0,0-1.171,0v4.248a.243.243,0,0,1-.242.242h-2.435a.243.243,0,0,1-.242-.242v-7.728a.243.243,0,0,1,.242-.242h2.435a.243.243,0,0,1,.242.242v.768A.585.585,0,0,0,449.674,251.091Z'
        transform='translate(-410.26 -228.85)'
      />
      <path
        d='M466.316,280.8l-.561-.678a.586.586,0,0,0-.911.011l-.534.678a.586.586,0,1,0,.92.725l.086-.109.1.119a.585.585,0,0,0,.9-.746Z'
        transform='translate(-427.948 -257.972)'
      />
      <path
        d='M466.239,328.382a.586.586,0,0,0-.824.078l-.1.119-.086-.109a.585.585,0,1,0-.92.725l.534.678a.585.585,0,0,0,.453.223h.007a.586.586,0,0,0,.451-.212l.561-.678A.585.585,0,0,0,466.239,328.382Z'
        transform='translate(-427.949 -302.534)'
      />
    </g>
  </svg>
)

export default Elevator
